module.exports = __webpack_public_path__ + "img/hisa.1feb509f.gif";